module.exports = __webpack_public_path__ + "static/img/6.5ea9c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/6.jpg
// module id = RqxU
// module chunks = 4